var $ = require('jquery');
const showcase_heroes = document.querySelectorAll('.hero--article-showcase');
const showcase_slide_timer = 5000;
let interval_check_youtube_loaded;

// This array will hold an object with the data for each showcase hero. This will allow multiple showcase heroes to be used on the same page.
const showcase_controller = [];

try {

	// If there are showcase heroes on this page, populate the `showcase_controller` array with data for those heroes.
	if( showcase_heroes.length ){

		for( let i=0; i<showcase_heroes.length; i++ ){

			let new_showcase = {
				hero: showcase_heroes[i],
				active_tab: 0,
				slides: Array.prototype.slice.call( showcase_heroes[i].querySelectorAll('.hero__showcase-slide') ),
				tabs: Array.prototype.slice.call( showcase_heroes[i].querySelectorAll('.hero__tab') ),
				youtubeIframes: [],
				youtubePlayers: [],
				interval: false//setInterval( ali_showcase_start_slider, showcase_slide_timer ),
			};

			for( let j=0; j<new_showcase.slides.length; j++ ){
				if( new_showcase.slides[j].querySelector('iframe[src*="youtube.com"]') ){
					// new_showcase.youtubeIframes.push( new_showcase.slides[j].querySelector('iframe[src*="youtube.com"]') );
					new_showcase.youtubeIframes[j] = new_showcase.slides[j].querySelector('iframe[src*="youtube.com"]');
				}
			}

			// showcase_controller.push( new_showcase );
			showcase_controller[i] = new_showcase;

			ali_showcase_set_active_tab( i, new_showcase.active_tab );

		}
		// console.log('showcase_controller = ', showcase_controller);

		// ali_showcase_start_slider();
		ali_check_youtube_is_loaded();

	}
	// console.log( 'showcase_controller = ');
	// console.log( showcase_controller );

}
catch(error){
	console.log('Error setting up showcase:');
	console.log(error);
}


// When attached to an interval, this function will loop through each showcase and increment the active slide.
function ali_showcase_start_slider(){
	try {

		for( let i=0; i<showcase_controller.length; i++ ){

			let active_tab = showcase_controller[i].active_tab;

			ali_showcase_set_active_tab( i, active_tab );

			// Increment the active tab number so that the next time this function is run in an interval, the next slide will be the active one. Also make sure to reset the number back to 0 when it goes over the number of tabs/slides.
			active_tab++;
			if( active_tab >= showcase_controller[i].tabs.length ){
				active_tab = 0;
			}
			showcase_controller[i].active_tab = active_tab;

		}

	}
	catch(error){
		console.log('Error starting showcase slider:');
		console.log(error);
	}
}


// When a tab's heading is clicked, that tab and the corresponding slide should be made active.
function ali_showcase_tab_click_cb( e ){
	try {

		if( e.target.classList.contains('button') ){
			return true;
		}

		// e.preventDefault();
		// console.log(e.target);

		// Get the parent `.hero` container for this clicked tab.
		let parent_hero = e.target;
		do {
			parent_hero = parent_hero.parentNode;
		}
		while( !parent_hero.classList.contains('hero') && parent_hero !== document.body );

		// Get the the parent `.hero__tab` container.
		let parent_tab = e.target;
		do {
			parent_tab = parent_tab.parentNode;
		}
		while( !parent_tab.classList.contains('hero__tab') && parent_tab !== document.body );

		// For this tab, find the matching hero in the showcase_controller array. Use the `parent_hero` that was just found to make the match.
		let this_showcase_index = false;
		for( let i=0; i<showcase_controller.length; i++ ){
			if( parent_hero == showcase_controller[i].hero ){
				this_showcase_index = i;
			}
		}

		// For this tab, find the index for its position in the showcase_controller array. We can use this index later to match the tab with its corresponding slide.
		let this_tab_index = false;
		if( this_showcase_index !== false ){
			for( let i=0; i<showcase_controller[this_showcase_index].tabs.length; i++ ){
				if( parent_tab == showcase_controller[this_showcase_index].tabs[i] ){
					this_tab_index = i;
				}
			}
		}

		// Set the new active tab and stop the interval that runs the slider.
		if( this_tab_index !== false ){
			ali_showcase_set_active_tab( this_showcase_index, this_tab_index );
			// clearInterval( showcase_controller[this_showcase_index].interval );
		}

	}
	catch(error){
		console.log('Error clicking a showcase tab.');
		console.log(error);
	}

	return false;
}



let touchmoved = true;

function ali_showcase_tab_touchend_cb(e){
	// console.log('touched tab');
	// console.log(e);

	try {

		if( !touchmoved && window.innerWidth <= 860 ){

			// Get the parent `.hero` container for this clicked tab.
			let parent_hero = e.target;
			do {
				parent_hero = parent_hero.parentNode;
			}
			while( !parent_hero.classList.contains('hero') && parent_hero !== document.body );

			let this_showcase_index = false;
			for( let i=0; i<showcase_controller.length; i++ ){
				if( parent_hero == showcase_controller[i].hero ){
					this_showcase_index = i;
				}
			}
			// console.log('this_showcase_index = ' + this_showcase_index);
			// console.log(showcase_controller[this_showcase_index]);

			if( this_showcase_index !== false ){
					let scroll_distance = showcase_controller[this_showcase_index].hero.getBoundingClientRect().height + 95 - window.innerHeight;
					window.scrollTo({
						top: scroll_distance,
						behavior: "smooth"
			 		});
			}

		}

	}
	catch(error){
		console.log('Error touching a showcase tab.');
		console.log(error);
	}

}

function ali_showcase_tab_touchstart_cb(){
	touchmoved = false;
}

function ali_showcase_tab_touchmove_cb(){
	touchmoved = true;
}

// const showcase_tab_links = document.querySelectorAll('.hero__tab-title-link');
// for( let i=0; i<showcase_tab_links.length; i++ ){
// 	showcase_tab_links[i].addEventListener( 'click', ali_showcase_tab_click_cb );
// }
const showcase_tabs = document.querySelectorAll('.hero__tab');
for( let i=0; i<showcase_tabs.length; i++ ){
	showcase_tabs[i].addEventListener( 'click', ali_showcase_tab_click_cb, {passive: true} );
	showcase_tabs[i].addEventListener( 'touchend', ali_showcase_tab_touchend_cb, {passive: true} );
	showcase_tabs[i].addEventListener( 'touchstart', ali_showcase_tab_touchstart_cb );
	showcase_tabs[i].addEventListener( 'touchmove', ali_showcase_tab_touchmove_cb, {passive: true} );
}



function ali_showcase_set_active_tab( showcase_index, tab_index ){

	try {

		showcase_controller[showcase_index].slides.map( (this_bg) => {
			this_bg.classList.remove('hero__showcase-slide--is-active');
		} );

		showcase_controller[showcase_index].tabs.map( (this_tab) => {
			this_tab.classList.remove('hero__tab--is-active');
		} );

		showcase_controller[showcase_index].slides[tab_index].classList.add('hero__showcase-slide--is-active');
		showcase_controller[showcase_index].tabs[tab_index].classList.add('hero__tab--is-active');

		if( showcase_controller[showcase_index].youtubePlayers[tab_index] ){
			// console.log( 'attempt to play video ', showcase_controller[showcase_index].youtubePlayers[tab_index]);
			showcase_controller[showcase_index].youtubePlayers[tab_index].playVideo();
		}

		// bio_container.offset().top
		// const scroll_amount = showcase_controller[showcase_index].tabs[tab_index].getBoundingClientRect().left - 48;
		// var scroll_amount = $(showcase_controller[showcase_index].tabs[tab_index]).offset().left - 48;
		const scroll_amount = showcase_controller[showcase_index].tabs[tab_index].getBoundingClientRect().width * (tab_index);
		// console.log( 'x scroll amount:' );
		// console.log(scroll_amount);
		$(showcase_controller[showcase_index].tabs[tab_index].parentNode.parentNode).animate(
			{
				scrollLeft: scroll_amount
			},
			333
		);

		showcase_controller[showcase_index].active_tab = tab_index;

	}
	catch(error){
		console.log('Error setting the active tab and slide.');
		console.log(error);
	}

}

function onPlayerReady(e){
	e.target.playVideo();
}

function onPlayerStageChange(e){
	// console.log('onPlayerStageChange() event.data = ', e.data );
	if( e.data === 0 ){
		e.target.playVideo();
	}
}


function ali_check_youtube_is_loaded(){
	interval_check_youtube_loaded = setInterval( () => {
		try {
			// console.log('Check if YouTube is loaded...');

			if( typeof YT.Player === 'function' ){
				console.log('YouTube loaded.');
				clearInterval(interval_check_youtube_loaded);

				for( let i=0; i<showcase_controller.length; i++ ){
					for( let j=0; j<showcase_controller[i].youtubeIframes.length; j++ ){
						if( showcase_controller[i].youtubeIframes[j] ){
							const standard_options = {
								events: {
								'onStateChange': onPlayerStageChange
								}
							};
							const first_tab_options = {
								events: {
									'onReady': onPlayerReady,
									'onStateChange': onPlayerStageChange
								}
							}

							let yt_options = standard_options;
							if( i===0 && j === 0 ){
								yt_options = first_tab_options;
							}

							showcase_controller[i].youtubePlayers[j] = new YT.Player( showcase_controller[i].youtubeIframes[j], yt_options);
							// console.log('player = ', showcase_controller[i].youtubePlayers[j]);
						}

					}
				}

			}

		} catch (error) {
			console.log('Checking if YouTube Iframe script is loaded:', error);
		}

	}, 100);

	setTimeout( () => {
		clearInterval(interval_check_youtube_loaded);
	}, 30000);
}
